import React from 'react';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, Typography} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';



function createData(name, confirmed, recovered, deaths) {
    return { name, confirmed, recovered, deaths };
}

function CasesTable({data}) {
    const mediaBreakpoint = useMediaQuery('(max-width: 500px)');
    const useStyles = makeStyles({
        header: {
            marginBottom: 8
        },
        table: {
            marginLeft: 'auto',
            marginRight: 'auto'
        },
        headerCell: {
            width: '25%',
            fontSize: mediaBreakpoint ? '0.70rem' : '1rem',
            borderBottom: '1px solid #fafafa'
        },
        headerCellConfirmed: {
            width: '25%',
            fontSize: mediaBreakpoint ? '0.70rem' : '1rem',
            borderBottom: '1px solid #fafafa',
            backgroundColor: '#e0f2f1'
        },
        headerCellRecovered: {
            width: '25%',
            fontSize: mediaBreakpoint ? '0.70rem' : '1rem',
            borderBottom: '1px solid #fafafa',
            backgroundColor: '#c8e6c9'
        },
        headerCellDeaths: {
            width: '25%',
            fontSize: mediaBreakpoint ? '0.70rem' : '1rem',
            borderBottom: '1px solid #fafafa',
            backgroundColor: '#ff8a80'
        },
        bodyCell: {
            height: 56,
            fontSize: mediaBreakpoint ? '1.20rem' : '2rem',
            borderBottom: '1px solid #fafafa'
        },
        bodyCellConfirmed: {
            height: 56,
            fontSize: mediaBreakpoint ? '1.20rem' : '2rem',
            borderBottom: '1px solid #fafafa',
            backgroundColor: '#e0f2f1'
        },
        bodyCellRecovered: {
            height: 56,
            fontSize: mediaBreakpoint ? '1.20rem' : '2rem',
            borderBottom: '1px solid #fafafa',
            backgroundColor: '#c8e6c9'
        },
        bodyCellDeaths: {
            height: 56,
            fontSize: mediaBreakpoint ? '1.20rem' : '2rem',
            borderBottom: '1px solid #fafafa',
            backgroundColor: '#ff8a80'
        },
        provName: {
            height: 56,
            fontSize: mediaBreakpoint ? '0.70rem' : '1rem',
            borderBottom: '1px solid #fafafa'
        },
        confirmed: {
            backgroundColor: '#e0f2f1'
        },
        recovered:{
            backgroundColor: '#c8e6c9'
        },
        deaths: {
            backgroundColor: '#ff8a80'
        }
    });


    const classes = useStyles();

    let rows = []

    if(data.length > 0) {
        rows  = []
        data.map(o => {
            return rows.push(createData(o.name, o.confirmed, o.recovered, o.deaths))
        })
    }

    return <div className='section'>
        <Typography variant="h4" align="left" className={classes.header}>Province/Territory Situation</Typography>
        <TableContainer className={classes.table} component={Paper}>
            <Table className={classes.table}  aria-label="covid-19 cases by province">
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.headerCell}>Province/Territory</TableCell>
                        <TableCell className={classes.headerCellConfirmed}>Confirmed</TableCell>
                        <TableCell className={classes.headerCellRecovered}>Recovered</TableCell>
                        <TableCell className={classes.headerCellDeaths}>Deaths</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map(row => (
                        <TableRow key={row.name}>
                            <TableCell className={classes.provName}>{row.name}</TableCell>
                            <TableCell className={classes.bodyCellConfirmed}>{Number(row.confirmed).toLocaleString('en')}</TableCell>
                            <TableCell className={classes.bodyCellRecovered}>{Number(row.recovered).toLocaleString('en')}</TableCell>
                            <TableCell className={classes.bodyCellDeaths}>{Number(row.deaths).toLocaleString('en')}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>

    </div>
}

export default CasesTable